<form name="eventForm" [formGroup]="eventForm" novalidate>

    <header-bar [pageTitle]="title" headingClass="fa-circle-o"></header-bar>

    <div class="container mt-5 mb-5">
        <div class="row">
            <div class="col">
                <div class="card mb-5">
                    <div class="card-header bg-primary text-white">
                        <div class="row align-items-center">
                            <p class="h3 m-0 col">Event details</p>
                            <div class="col text-right">
                                <button type="submit" class="btn btn-outline-light btn-sm u-marginBottom--medium"
                                    [disabled]="!eventForm.valid"
                                    (click)="saveTimelineEvent(eventForm.value, eventForm.valid, true)">
                                    <span *ngIf="id == null">Publish event</span>
                                    <span *ngIf="id != null">Publish changes</span>
                                    <i class="fa fa-check ml-2"></i>
                                </button>
                                <button type="submit" class="btn btn-outline-light btn-sm u-marginBottom--medium"
                                    [disabled]="!eventForm.valid || eventForm.controls['disabled'].value"
                                    (click)="latestUpdateModal.openModal();">
                                    Publish and notify <i class="fa fa-check ml-2"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col">
                                <p class="textBody--xs u-marginBottom--medium">Please complete all fields marked with an
                                    asterix (*)</p>

                                <div class="row"
                                    [ngClass]="{ 'has-error' : !eventForm.controls['text'].valid && eventForm.controls['text'].touched }">
                                    <div class="col">
                                        <div class="form-group">
                                            <label for="title">Event headline *</label>
                                            <ckeditor formControlName="text"
                                                      [config]="textEditorConfig"
                                                      [editor]="Editor"
                                                      ckEditorEnhanced>
                                            </ckeditor>
                                            <div *ngIf="eventForm.controls['text'].hasError('required') && eventForm.controls['text'].touched"
                                                class="alert alert-danger">You must include a headline.</div>
                                            <div *ngIf="eventForm.controls['text'].hasError('trimmedminlength') && eventForm.controls['text'].touched"
                                                class="alert alert-danger">The event headline must be at least 3
                                                characters long.</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row"
                                    [ngClass]="{ 'has-error' : !eventForm.controls['url'].valid && eventForm.controls['url'].touched }">
                                    <div class="col">
                                        <div class="form-group">
                                            <label for="title">Supporting documentation link</label>

                                            <p class="textBody--xs">You may include a link to supporting documentation
                                                below.</p>
                                            <input type="text" class="form-control" formControlName="url" name="url" />
                                            <div *ngIf="eventForm.controls['url'].invalid && eventForm.controls['url'].touched"
                                                class="alert alert-danger">Please include http:// or https:// to the
                                                beginning of your URL </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div class="form-group">
                                            <label for="title">Location *</label>
                                            <input name="countryId" class="form-control" formControlName="countryId"
                                                *ngIf="false" />
                                            <ng-select id="countrySelector" [allowClear]="true" *ngIf="selectedCountry"
                                                [items]="countries" [active]="selectedCountry"
                                                placeholder="Select a country" (selected)="countrySelected($event)">
                                            </ng-select>
                                            <div *ngIf="eventForm.controls['countryId'].hasError('required') && countryNotSelected && !eventForm.valid"
                                                class="alert alert-danger">Location is required.</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div class="form-group">
                                            <label for="title">Publish date *</label>
                                            <input type="date" class="form-control" formControlName="publishDate"
                                                name="publishDate" />
                                            <div *ngIf="eventForm.controls['publishDate'].hasError('required') && eventForm.controls['publishDate'].touched"
                                                class="alert alert-danger">Publish Date is required.</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <label for="deleted">Is this event disabled?</label>
                                        <input type="checkbox" name="disabled" formControlName="disabled"
                                            class="u-marginTop--small" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>

<confirmationmodal #confirmModal (onAccept)="onAccept();"></confirmationmodal>
<!--<ckeditor debounce="10">
</ckeditor>-->
<latestupdatemodal #latestUpdateModal [(latestUpdate)]="updateText"
    (onLatestUpdateUpdated)="saveTimelineEvent(eventForm.value, eventForm.valid, false); publishContent($event);">
</latestupdatemodal>